import React, { Fragment } from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import skeletons from './Skeletons';
import Tooltip from '../../../../Tooltip';
import ErrorStateWithReload from '../../../../ErrorStateWithReload';
import BarWithTick from '../../../../../pages/app-insights/_shared/components/BarWithTick';
import RenderEmptyState from '../../../../../pages/app-insights/_shared/components/RenderEmptyState';

const widgetsTypes = {
  performance: 'Growth',
  engagement: 'Engagement',
  // retention: 'Retention',
};

const widgetsTooltipsFor = (metric, categoryName) => (
  {
    performance: `Growth benchmark compares an app's download performance to other apps in the ${categoryName} category, for the same set of filters, as a percentile.`,
    engagement: `Engagement benchmark compares an app's frequency of use to other apps in the ${categoryName} category, for the same set of filters, as a percentile.`,
    retention: `Retention benchmark compares an app's 30-day retention rate to other apps in the ${categoryName} category, for the same set of filters, as a percentile.`,
  }[metric]
);

const WidgetPerformance = ({ widgets, settings, app }) => {
  const { insights } = widgets;
  const { pending, error } = settings;
  const isEmptyData = !pending && isEmpty(insights);

  const body = (type) => {
    if (pending) return skeletons.widgetPerformance;
    if (!insights[type]) return null;

    return (
      <Fragment>
        <div className="widget-body__title">
          {widgetsTypes[type]}
          <Tooltip content={widgetsTooltipsFor(type, insights.categories[app.store])}>
            <span className="cursor-pointer tooltip-icon">
              <i className="hicon-question-circle" />
            </span>
          </Tooltip>
        </div>
        <BarWithTick
          percentage={insights[type].value}
          title={insights[type].value_text}
          change={insights[type].value_change}
        />
      </Fragment>
    );
  };
  if (error) return <ErrorStateWithReload />;

  return (
    <div className="widget-section">
      {!isEmptyData
        ? Object.keys(widgetsTypes).map(widget => (
          <div key={widget} className="widget-body">{body(widget)}</div>
        ))
        : <RenderEmptyState />}
    </div>
  );
};

WidgetPerformance.propTypes = {
  widgets: T.object.isRequired,
  settings: T.object.isRequired,
  app: T.object.isRequired,
};

export default WidgetPerformance;
